import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import TaskModalRoot from "../TaskModalRoot";

const SIZE_CLASS = {
  md: "max-w-xl",
  lg: "max-w-3xl",
  xl: "max-w-4xl",
};

function TaskModalShell({
  open,
  onClose,
  title,
  subtitle,
  eyebrow,
  children,
  footer,
  size = "lg",
}) {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.lg;

  return (
    <TaskModalRoot open={open} onBackdropClick={onClose}>
      <div
        className={`relative z-10 flex w-full ${sizeClass} max-h-[min(90vh,720px)] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="dal-modal-title"
      >
        <div className="flex shrink-0 items-center justify-between gap-3 border-b border-gray-100 px-6 py-4">
          <div className="min-w-0 flex-1">
            {eyebrow ? (
              <p className="text-xs font-semibold uppercase tracking-wide text-[#007BFF]">
                {eyebrow}
              </p>
            ) : null}
            <h3
              id="dal-modal-title"
              className={`text-lg font-bold text-[#35314d] ${eyebrow ? "mt-0.5" : ""}`}
            >
              {title}
            </h3>
            {subtitle ? (
              <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700"
            aria-label="Close"
          >
            <FaTimes size={14} />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-6 py-5 pb-6">
          {children}
        </div>

        {footer ? (
          <div className="flex shrink-0 items-center justify-end gap-2 border-t border-gray-100 bg-white px-6 py-4">
            {footer}
          </div>
        ) : null}
      </div>
    </TaskModalRoot>
  );
}

export default TaskModalShell;
